import * as React from "react";

import "./date-modal.scss";

import {cs}                 from "@Common/react/chain-services";
import {UseState}           from "@Common/react/use-state";
import {consumeContext}     from "@Common/react/context";
import {DatePicker2}        from "@Common/ui-components/date-picker-2/date-picker-2";
import {ModalService3}      from "@Common/ui-components/modal-service-3/modal-service-3";
import {parseDate, addDate} from "@Common/utils/date-object";

import {ModalLayout} from "../modal-layout/modal-layout";

export const DateModal = ({
    getTitle=undefined,
    className,
    hasError = false,
    isDateDisabled = d => false,
    onClick=undefined,
    minDate,
    dateFormat,
    xdQaName,
    next: rootNext,
}) => cs(
    consumeContext("systemConstants"),
    ["modal", ({}, next) => ModalService3({
        xdQaName: "Date Modal",
        width: 400,
        next: ({params, close}) => next({
            close,
            currentDate: params.currentDate,
            params,
        }),
        rootNext,
    })],
    ["updating", (_, next) => UseState({next})],
    ["date", (_, next) => UseState({
        defaultValue: null,
        next,
    })],
    ["maxDate", ({modal, systemConstants}, next) => {
        const orderDate = parseDate(modal.params.orderDate);
        const maxDate = addDate(orderDate, +(systemConstants.value?.MAX_NUM_DAYS_OUT_FOR_SCHEDULING_ORDERS??90))
        return next(maxDate);
    }],
    ({modal, date, updating, maxDate}) => ModalLayout({
        title: getTitle() || "Please Define a Title",
        content: (
            <div className="date-modal-2f6">
                <div className="date-picker">
                    {DatePicker2({
                        className,
                        state: date,
                        hasError,
                        minDate,
                        maxDate,
                        dateFormat,
                        isDisabled: (d) => isDateDisabled({d, maxDate}),
                        xdQaName,
                    })}
                </div>
            </div>
        ),
        buttons: [
            {
                label: "Cancel",
                onClick: () => modal.close(),
            },
            ({
                label: updating.value ? updating.value : "Confirm Date",
                primary: true,
                disabled: !!updating.value || !date.value || isDateDisabled({d: date.value, maxDate}),
                onClick: async () => {
                    updating.onChange("Updating Date");
                    await onClick({date: dateFormat.formatDate(date.value), params: modal.params});
                    updating.onChange(null);
                    modal.close();
                },
            }),
        ],
    }),
);
